import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState(13 * 60);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const timer = setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, [secondsLeft]);
  const minutes = String(Math.floor(secondsLeft / 60)).padStart(2, '0');
  const seconds = String(secondsLeft % 60).padStart(2, '0');
  return <div className="flex flex-col items-center justify-center mb-8" data-id="element-259">
      <div className="flex items-center gap-2 text-red-500 font-bold uppercase tracking-wider text-sm sm:text-base mb-3 animate-pulse" data-id="element-260">
        <Clock className="w-5 h-5" data-id="element-261" />
        ¡Tu oferta especial reservada expira en!
      </div>
      <div className="flex items-center gap-3" role="timer" aria-live="polite" data-id="element-262">
        <div className="flex flex-col items-center bg-[#1a1a1a] border border-gold/40 rounded-lg px-5 py-3 min-w-[80px]" data-id="element-263">
          <span className="font-oswald text-4xl sm:text-5xl font-bold text-white tabular-nums" data-id="element-264">
            {minutes}
          </span>
          <span className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-widest mt-1" data-id="element-265">
            Minutos
          </span>
        </div>
        <span className="font-oswald text-4xl sm:text-5xl font-bold text-gold" data-id="element-266">
          :
        </span>
        <div className="flex flex-col items-center bg-[#1a1a1a] border border-gold/40 rounded-lg px-5 py-3 min-w-[80px]" data-id="element-267">
          <span className="font-oswald text-4xl sm:text-5xl font-bold text-white tabular-nums" data-id="element-268">
            {seconds}
          </span>
          <span className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-widest mt-1" data-id="element-269">
            Segundos
          </span>
        </div>
      </div>
    </div>;
}